@use "~theme/breakpoints";
@use "~theme/typography";

.container {
  padding: 24px 24px 40px;

  @include breakpoints.desktop {
    padding: 32px 40px 40px;
  }
}

.card {
  position: relative;
  display: grid;
  gap: 24px;
  border: 1px solid var(--blue-01-at-30);
  padding: 16px 28px;
  border-radius: 4px;
  background-color: var(--blue-03-at-30);
}

.cardTitle {
  @include typography.body-semibold;
}

.edit {
  position: absolute;
  top: 52px;
  right: 24px;
}

.editLink {
  @include typography.body-semibold;
  text-transform: uppercase;
}
